/* ==========================================================================
   MT — JavaScript compartido. Todo el JS propio del tema vive aquí.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__mtScriptsLoaded) return;
  window.__mtScriptsLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll (compartido por toda la tienda) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCifras() {
    var els = document.querySelectorAll('[data-mt-cifra]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-mt-cifra'));
      var decimales = el.getAttribute('data-mt-decimales') ? Number(el.getAttribute('data-mt-decimales')) : 0;
      if (isNaN(fin)) return;
      if (reducedMotion) { el.textContent = fin.toFixed(decimales); return; }
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (inicio === null) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { animar(entry.target); observer.unobserve(entry.target); }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- FAQ desplegable ---- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var boton = item.querySelector('.mt-faq-pregunta');
      var respuesta = item.querySelector('.mt-faq-respuesta');
      if (!boton || !respuesta) return;
      boton.addEventListener('click', function () {
        var abierta = item.getAttribute('data-abierto') === 'true';
        items.forEach(function (otro) {
          otro.setAttribute('data-abierto', 'false');
          var r = otro.querySelector('.mt-faq-respuesta');
          if (r) r.style.maxHeight = null;
        });
        if (!abierta) {
          item.setAttribute('data-abierto', 'true');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Galería de producto ---- */
  function initGaleria() {
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-mt-full');
        var alt = mini.getAttribute('data-mt-alt') || '';
        if (!full) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = full;
          principal.alt = alt;
          principal.style.opacity = '1';
        }, 150);
        minis.forEach(function (m) { m.setAttribute('data-activa', 'false'); });
        mini.setAttribute('data-activa', 'true');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var inputId = form.querySelector('input[name="id"]');
      var botonesOpcion = form.querySelectorAll('[data-mt-opcion-valor]');
      var precioActual = document.querySelector('[data-mt-precio-actual]');
      var precioAnterior = document.querySelector('[data-mt-precio-anterior]');
      var botonComprar = form.querySelector('[data-mt-boton-comprar]');
      var stockMsg = form.querySelector('[data-mt-stock-msg]');

      function opcionesSeleccionadas() {
        var seleccion = [];
        var grupos = {};
        form.querySelectorAll('[data-mt-opcion-valor][data-seleccionada="true"]').forEach(function (btn) {
          grupos[btn.getAttribute('data-mt-opcion-indice')] = btn.getAttribute('data-mt-opcion-valor');
        });
        var indices = Object.keys(grupos).sort();
        indices.forEach(function (i) { seleccion.push(grupos[i]); });
        return seleccion;
      }

      function formatoDinero(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      function actualizar() {
        var seleccion = opcionesSeleccionadas();
        var variante = variantes.find(function (v) {
          return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!variante) return;
        if (inputId) inputId.value = variante.id;
        if (precioActual) precioActual.textContent = formatoDinero(variante.price);
        if (precioAnterior) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAnterior.textContent = formatoDinero(variante.compare_at_price);
            precioAnterior.hidden = false;
          } else {
            precioAnterior.hidden = true;
          }
        }
        if (botonComprar) botonComprar.disabled = !variante.available;
        if (botonComprar) botonComprar.querySelector('[data-mt-boton-texto]') &&
          (botonComprar.querySelector('[data-mt-boton-texto]').textContent = variante.available ? botonComprar.getAttribute('data-mt-texto-disponible') : botonComprar.getAttribute('data-mt-texto-agotado'));
        if (stockMsg) {
          if (variante.available) {
            stockMsg.textContent = stockMsg.getAttribute('data-mt-texto-stock') || '';
            stockMsg.className = 'mt-stock-msg mt-ok';
          } else {
            stockMsg.textContent = stockMsg.getAttribute('data-mt-texto-agotado-stock') || '';
            stockMsg.className = 'mt-stock-msg mt-agotado';
          }
        }
        var imagenId = variante.featured_media_id;
        if (imagenId) {
          var mini = form.closest('.mt-producto-grid') && form.closest('.mt-producto-grid').querySelector('[data-mt-galeria-mini][data-media-id="' + imagenId + '"]');
          if (mini) mini.click();
        }
      }

      botonesOpcion.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.getAttribute('data-mt-opcion-indice');
          form.querySelectorAll('[data-mt-opcion-valor][data-mt-opcion-indice="' + grupo + '"]').forEach(function (b) {
            b.setAttribute('data-seleccionada', 'false');
          });
          btn.setAttribute('data-seleccionada', 'true');
          actualizar();
        });
      });

      actualizar();
    });
  }

  /* ---- Código de descuento en el carrito (se aplica al pasar por caja) ---- */
  function initDescuentoCarrito() {
    var input = document.getElementById('mt-codigo-descuento');
    var form = document.getElementById('cart');
    if (!input || !form) return;

    form.addEventListener('submit', function () {
      var codigo = input.value.trim();
      if (!codigo) return;
      var url = new URL(form.action, window.location.origin);
      url.searchParams.set('discount', codigo);
      form.action = url.pathname + url.search;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCifras();
    initFaq();
    initGaleria();
    initVariantes();
    initDescuentoCarrito();
  });
})();
